export class CommonTool {

    constructor() { }

    /**
     * @function commonTool.getUrlParameter
     * @description 获取url参数对象(?号后的参数)
     */
    public static getUrlParameter(): any {
        let url = location.search;
        if (url.indexOf("?") != -1) {
            let lets = url.substr(1).split("&");
            let query_string = {}
            for (let i = 0; i < lets.length; i++) {
                let pair = lets[i].split("=");
                let key = decodeURIComponent(pair[0]);
                let value = decodeURIComponent(pair[1]);
                // If first entry with this name
                if (typeof query_string[key] === "undefined") {
                    query_string[key] = decodeURIComponent(value);
                    // If second entry with this name
                } else if (typeof query_string[key] === "string") {
                    let arr = [query_string[key], decodeURIComponent(value)];
                    query_string[key] = arr;
                    // If third or later entry with this name
                } else {
                    query_string[key].push(decodeURIComponent(value));
                }
            }
            return query_string;
        }

        return null;
    }

    public static encodeUrlParams() {
        let params = location.search.split("?")[1];
        return encodeURIComponent(params);
    }

    /**
     * 设置url中的参数
     * @param path url路径
     * @param paramDefaults 配置参数
     * @param data 数据上下文
     * @returns 
     */
    public static setUrlParams(path: string, paramDefaults: { [name: string]: string }, data: any): string {

        let url = path;

        if (paramDefaults) {
            for (const key in paramDefaults) {
                if (Object.prototype.hasOwnProperty.call(paramDefaults, key)) {

                    const oringinalValue = paramDefaults[key];

                    let value = oringinalValue && oringinalValue.charAt && oringinalValue.charAt(0) === '@' ? this.lookupDottedPath(data, oringinalValue.substr(1)) : oringinalValue;

                    if (value === undefined || value === null || value === "") {

                        //当数据中没有传参数时，去除URL中的路径参数以及查询参数
                        url = url.replace("/:" + key, "");
                        url = url.replace("[\w]+=:" + key + "[&]?", "");
                    } else {
                        //当数据中有传参数时，设置URL参数
                        if (RegExp(":" + key).test(url)) {
                            //替换path中已有参数
                            url = url.replace(":" + key, value);
                        } else {
                            //增加参数到路径中
                            var myParam = "";

                            if (angular.isArray(value)) {
                                let myParams: Array<string> = [];
                                if (value.length > 0) {
                                    for (let index = 0; index < value.length; index++) {
                                        const element = value[index];
                                        myParams.push(key + "=" + element);
                                    }
                                }

                                myParam = myParams.join("&");
                            } else {
                                myParam = key + "=" + value;
                            }

                            if (url.indexOf("?") > -1) {
                                url = url + "&" + myParam;
                            } else {
                                url = url + "?" + myParam;
                            }
                        }
                    }
                }
            }
        }

        return url;
    }

    /**
     * @description 校验url是否为全路径地址
     * @param path url路径
     * @returns 
     */
    public static fullUrlVerify(path: string): boolean {
        const http_reg = /^(http:|https:)/ig;
        return http_reg.test(path);
    }

    /**
     * @description 获取url地址中包含的文件文件名（xxxx.jpg）
     * @param path url路径
     * @returns 
     */
    public static getUrlFileName(path: string): string {
        const splitArray = path.split('/');
        let fileName: string;
        if (splitArray.length > 0) {
            fileName = splitArray[splitArray.length - 1];
        } else {
            fileName = path;
        }
        return fileName;
    }

    /**
     * @function commonTool.isExpire
     * @description 检查是否过期
     * @param expireDate 过期时间
     * @return true:过期，false：未过期
     */
    public isExpire(expireDate: number): boolean {
        let currentData = new Date().getTime();
        return expireDate > currentData ? false : true;
    }

    /**
     * @param expireTime 
     * @returns 
     */
    public convertExpireDate(expireTime: number): number {
        return expireTime * 1000 + new Date().getTime();
    }

    /***************************** Commom Form 内容********************************/

    /** 
     * @param configs 
     * @param type 
     * @param name 
     * @description 根据 type 和 name 在configs中 查找相对应的模板配置
     */
    public static findTemplateByTypeAndName(configs: Array<any>, type: string, name: string): Array<string> | undefined {
        if (configs && type && name) {
            let config = configs.find(o => o.type == type && o.name.toLocaleLowerCase() == name.toLocaleLowerCase());
            return config ? config.values : undefined;
        }
    }

    /**
     * @param template 模板
     * @param content 替换内容
     * @param key 替换关键字
     */
    public static stringReplaceContent(template: string, content: string, key: string): string {
        let regex = new RegExp("\\$\\{\\s*" + key + "\\s*\\}", "gi");
        return template.replace(regex, content);
    }
}